// /src/utils/clevertap.ts
declare global {
  interface Window {
    clevertap: any;
  }
}

export function trackCharged(ontentData:any) {
  window.clevertap.event.push("Charged", {
    "Items": ontentData
  });
}

